'use client';
import React, { useState, useCallback } from 'react';

interface PageInputProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
  onScrollToTop?: () => void;
}

export function PageInput({ currentPage, totalPages, onPageChange, onScrollToTop }: PageInputProps) {
  const [pageInput, setPageInput] = useState(currentPage.toString());

  const handlePageInputChange = useCallback((value: string) => {
    setPageInput(value);
  }, []);

  const handlePageInputBlur = useCallback(() => {
    const pageNumber = parseInt(pageInput);
    const isValidPage = !isNaN(pageNumber) && pageNumber >= 1 && pageNumber <= totalPages;

    if (isValidPage) {
      onPageChange(pageNumber);
      onScrollToTop?.();
    } else {
      setPageInput(currentPage.toString());
    }
  }, [pageInput, totalPages, onPageChange, currentPage, onScrollToTop]);

  const handlePageInputKeyPress = useCallback(
    (e: React.KeyboardEvent) => {
      if (e.key === 'Enter') {
        handlePageInputBlur();
      }
    },
    [handlePageInputBlur],
  );

  return (
    <div className="flex items-center gap-2">
      <input
        type="text"
        value={pageInput}
        onChange={(e) => handlePageInputChange(e.target.value)}
        onBlur={handlePageInputBlur}
        onKeyPress={handlePageInputKeyPress}
        className="w-11 h-11 text-center border border-secondary-200 font-openSans text-base leading-6 focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary focus:ring-offset-2"
        style={{ borderRadius: '4px' }}
      />
      <span className="font-openSans text-base leading-6 text-gray-600">of {totalPages} pages</span>
    </div>
  );
}
